import React, { ReactElement } from 'react';
import { isDarkMode } from 'utils/helpers';

interface AddContentIconProps {
  cssStyle?: any;
  width?: number;
  height?: number;
}

const StarFillIcon = ({ cssStyle, height = 15, width = 16 }: AddContentIconProps): ReactElement => {
  return (
    <svg
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      // width="39" // height="39" {Default values for width and height from Figma}
      viewBox="0 0 39 39"
      fill="none"
      style={{ ...cssStyle }}
    >
      <g clip-path="url(#clip0_5662_7039)">
        <path
          d="M24.2939 13.9736L24.4121 14.252L24.7119 14.2773L37.4248 15.3555L27.7705 23.7197L27.542 23.918L27.6104 24.2119L30.5107 36.6426L19.583 30.0469L19.3242 29.8906L19.0664 30.0469L8.1377 36.6416L11.0381 24.2119L11.1064 23.918L10.8789 23.7197L1.22266 15.3555L13.9365 14.2773L14.2373 14.252L14.3545 13.9736L19.3242 2.24805L24.2939 13.9736Z"
          fill={isDarkMode() ? '#E84A6E' : '#EB6180'}
          stroke={isDarkMode() ? '#212121' : '#FCE8ED'}
        />
      </g>
      <defs>
        <clipPath id="clip0_5662_7039">
          <rect width="38.6486" height="38.6486" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default StarFillIcon;
